import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueSweetalert2 from "vue-sweetalert2";
import VeeValidate from "vee-validate";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VueI18n from "vue-i18n";
import en from "./assets/local/en.json";
import ar from "./assets/local/ar.json";
import arabic from "./assets/local/arabic.js";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@/assets/css/fonts.css";
Vue.config.productionTip = false;
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
const messages = {
  en,
  ar,
};

Vue.config.productionTip = false;
Vue.use(VueSweetalert2);

Vue.use(VueI18n);
Vue.use(VeeValidate, {
  locale: "ar",
  dictionary: {
    ar: arabic,
  },
});
const i18n = new VueI18n({
  locale: "ar",
  fallbackLocale: "ar",
  messages,
});
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
export const bus = new Vue();
